import * as types from "../types/categories"

const initialState = null

const categoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CATEGORIES:
      return [...action.data]
    case types.UPDATE_CATEGORY:
      return state.map(category =>
        category._id === action.newCategory._id
          ? action.newCategory
          : category
      )
    case types.ADD_CATEGORY:
      return [...state, action.newCategory]
    case types.DELETE_CATEGORY:
      return state.filter(category =>
        category._id !== action.categoryId
      )
    case types.CLEAR_CATEGORIES:
      return null
    default:
      return state
  }
}

export default categoriesReducer